export const RESOLVER_TITLE = "Resolver Conflito de Alocação";
export const SELECIONAR_CONFLITO_TITLE = "Selecionar Conflito";

export const JUSTIFICATIVA_MAX_LENGTH = 255;

export const CONFLITO_REQUIRED_MESSAGE = "Selecione o conflito que deseja resolver.";
export const ESCOLHA_REQUIRED_MESSAGE = "Escolha como deseja resolver o conflito.";
export const OBRA_REQUIRED_MESSAGE = "Selecione a obra que terá o local remanejado.";
export const LOCAL_REQUIRED_MESSAGE = "Selecione um local substituto.";
export const JUSTIFICATIVA_REQUIRED_MESSAGE = "Informe a justificativa para continuar.";
export const LOCAIS_EMPTY_MESSAGE =
  "Nenhum local disponível para o período da obra. Tente outro termo ou ignore o conflito.";
export const FORBIDDEN_MESSAGE = "Você não tem permissão para resolver conflitos de alocação.";
export const GENERIC_ERROR_MESSAGE = "Não foi possível concluir a ação. Tente novamente.";

export const IGNORADO_SUCCESS_MESSAGE =
  "Conflito marcado como tratado. A sobreposição agora aparece em verde no cronograma.";

export type ResolucaoTipo = "remanejar" | "ignorar";

export const RESOLUCAO_OPTIONS: { value: ResolucaoTipo; label: string; description: string }[] = [
  {
    value: "remanejar",
    label: "Remanejar Local",
    description: "Substitua o local em uma das obras para eliminar o conflito de datas.",
  },
  {
    value: "ignorar",
    label: "Ignorar Conflito",
    description:
      "Manter as duas obras neste local. Informe o motivo e a sobreposição passa a aparecer em verde no cronograma, como conflito tratado.",
  },
];

export const IGNORAR_GUIDANCE =
  "Informe uma justificativa para registrar o motivo de manter as obras neste local com datas sobrepostas.";
export const CONFLITO_LOAD_ERROR_MESSAGE =
  "Não foi possível carregar os dados do conflito. Tente novamente.";
export const LOCAIS_LOAD_ERROR_MESSAGE =
  "Não foi possível carregar os locais disponíveis. Tente novamente.";

export const COMO_RESOLVER_LABEL = "Como deseja resolver?";
export const QUAL_CONFLITO_LABEL = "Qual conflito deseja resolver?";
export const RECOMENDADO_LABEL = "RECOMENDADO";
export const STEP_SELECIONAR_LABEL = "Selecionar Local";
export const OBRA_SECTION_LABEL = "1. SELECIONE A OBRA PARA REMANEJAR O LOCAL";
export const LOCAL_SECTION_LABEL = "2. SELECIONE UM LOCAL SUBSTITUTO";
export const BUSCAR_LOCAL_PLACEHOLDER = "Buscar Local";
export const PERIODO_OBRA_LABEL = "Período da Obra";
export const PERIODO_ALOCADO_LABEL = "Período Alocado";
export const DISPONIVEL_LABEL = "Disponível";
export const INDISPONIVEL_LABEL = "Indisponível";
export const CONFLITO_DESCRICAO_CURTA =
  "Este local está alocado em obras distintas com datas sobrepostas no cronograma.";
export const GANTT_SECTION_LABEL = "Alocação de cada local";

export const REVISAO_LEGEND: { key: "obra" | "transferida" | "hoje"; label: string }[] = [
  { key: "obra", label: "Obra" },
  { key: "transferida", label: "Obra Transferida" },
  { key: "hoje", label: "Hoje" },
];
